var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":_vm.route,"target":"_blank"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("fa fa-external-link-alt")]),_c('span',[_vm._v(_vm._s(_vm.label))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }